import React from "react";
import PropTypes from "prop-types";
import { SubmittingButton, CloseIcon } from "../../uikit";
import { ModalDialog, inEmbedMode } from "../../../odc-ui";
import { friendlyDefaultCadence } from "../common/utilities";

const ConfirmationModal = ({
  authenticated,
  hasExistingAccount,
  selectedSubscriptionPlan,
  selectedSubscriptionPlanVariation,
  selectedProduct,
  cardBrand,
  selectedSquareCard,
  firstName,
  lastName,
  email,
  phone,
  selectedDateOfBirthMonthOption,
  selectedDateOfBirthDayOption,
  onSubmitClick,
  submittingForm,
  theme,
  onCloseClick,
}) => {
  return (
    <ModalDialog modalDialogClassName="add-funds-dialog" darkMode>
      <div>
        <a
          onClick={(e) => {
            e.preventDefault();
            onCloseClick();
          }}
        >
          <CloseIcon className="close-button" />
        </a>
        <div className="main-caption">
          You&apos;re setting up a subscription
        </div>
        <div className="details">
          <div className="detail">
            <span className="label">Plan: </span>
            <span className="value">{selectedSubscriptionPlan.name}</span>
          </div>
          <div className="detail">
            <span className="label">Frequency: </span>
            <span className="value">
              {friendlyDefaultCadence(selectedSubscriptionPlanVariation)}
            </span>
          </div>
          <div className="detail">
            <span className="label">Amount each cycle: </span>
            <span className="value">{selectedProduct.name}</span>
          </div>
          <div className="detail">
            <span className="label">Credit Card: </span>
            <span className="value">
              {cardBrand && `${cardBrand.toUpperCase()} `}
              **** **** ****{" "}
              {selectedSquareCard ? selectedSquareCard.last_4 : "****"}
            </span>
          </div>
          {!authenticated && (
            <>
              {
                <div className="detail">
                  <span className="label">Existing Healthcoin® User: </span>
                  <span className="value">
                    {hasExistingAccount ? "Yes" : "No"}
                  </span>
                </div>
              }
              {!hasExistingAccount && (
                <div className="detail">
                  <span className="label">Name: </span>
                  <span className="value">
                    {firstName} {lastName}
                  </span>
                </div>
              )}
              <div className="detail">
                <span className="label">Email: </span>
                <span className="value">{email}</span>
              </div>
              {!hasExistingAccount && (
                <div className="detail">
                  <span className="label">Phone: </span>
                  <span className="value">{phone}</span>
                </div>
              )}
              {!hasExistingAccount && (
                <div className="detail">
                  <span className="label">Birthday: </span>
                  <span className="value">
                    {selectedDateOfBirthMonthOption.label}{" "}
                    {selectedDateOfBirthDayOption.label}
                  </span>
                </div>
              )}
            </>
          )}

          <div className="detail">
            <div className="first-col">Notes:</div>
            <div>
              <ul>
                <li>
                  Your credit card will be charged automatically every cycle.
                </li>
                <li>
                  CAD $1 = 1 Healthcoin<sup>®</sup>
                </li>
                <li>
                  Access{" "}
                  <a
                    className="light-link underline"
                    href="/terms_and_conditions"
                  >
                    Terms & Conditions
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div className="actions">
          <SubmittingButton
            type={
              inEmbedMode()
                ? "embed"
                : theme === "paige"
                ? "primary-paige"
                : "primary"
            }
            fullWidth
            onClick={onSubmitClick}
            submitting={submittingForm}
            submittingText="Submitting..."
            text="Confirm"
            textTransform="none"
          />
        </div>
      </div>
    </ModalDialog>
  );
};

ConfirmationModal.propTypes = {
  authenticated: PropTypes.bool.isRequired,
  hasExistingAccount: PropTypes.bool.isRequired,
  selectedSubscriptionPlan: PropTypes.object.isRequired,
  selectedSubscriptionPlanVariation: PropTypes.object.isRequired,
  selectedProduct: PropTypes.object.isRequired,
  cardBrand: PropTypes.string,
  selectedSquareCard: PropTypes.object,
  firstName: PropTypes.string.isRequired,
  lastName: PropTypes.string.isRequired,
  email: PropTypes.string.isRequired,
  phone: PropTypes.string.isRequired,
  selectedDateOfBirthMonthOption: PropTypes.object.isRequired,
  selectedDateOfBirthDayOption: PropTypes.object.isRequired,
  onSubmitClick: PropTypes.func.isRequired,
  submittingForm: PropTypes.bool.isRequired,
  theme: PropTypes.string.isRequired,
  onCloseClick: PropTypes.func.isRequired,
};

export default ConfirmationModal;
